(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1320],{

/***/ 85569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Privacy; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/localization/i8intl.js + 2 modules
var i8intl = __webpack_require__(54269);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/constants/metaTags.js
var metaTags = __webpack_require__(89195);
// EXTERNAL MODULE: ./src/api/commonConstants.js
var commonConstants = __webpack_require__(96781);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/category/factCheck/correction-policy.js



 // import Ads from "components/ad/index.js";
// import Link from "next/link";











var CorrectionPolicy = function CorrectionPolicy() {
  var _useState = (0,react.useState)(""),
      language = _useState[0],
      setLanguage = _useState[1];

  var size = (0,commonConstants/* useWindowSize */.iP)();

  var _useState2 = (0,react.useState)(false),
      firstScroll = _useState2[0],
      setFirstScroll = _useState2[1];

  (0,react.useEffect)(function () {
    setLanguage((0,i8intl/* getLanguage */.G3)());

    function onFirstScroll() {
      return _onFirstScroll.apply(this, arguments);
    }

    function _onFirstScroll() {
      _onFirstScroll = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!firstScroll) {
                  setFirstScroll(true);
                  setTimeout(function () {
                    window.googletag = window.googletag || {
                      cmd: []
                    };
                    googletag.cmd.push(function () {
                      googletag.defineSlot('/1007232/Lallantop_Desktop_ROS_ATF_728x90', [[728, 90], [970, 250], [970, 90]], 'div-gpt-ad-1701945163318-0').addService(googletag.pubads());
                      googletag.defineSlot('/1007232/Lallantop_Desktop_ROS_MTF_1_728x90', [728, 90], 'div-gpt-ad-1701945220410-1').addService(googletag.pubads());
                      googletag.defineSlot('/1007232/Lallantop_Mobile_ROS_ATF_300x250', [[336, 280], [300, 250]], 'div-gpt-ad-1701946028239-0').addService(googletag.pubads());
                      googletag.defineSlot('/1007232/Lallantop_Mobile_ROS_MTF_1_300x250', [[336, 280], [300, 250]], 'div-gpt-ad-1701946028239-1').addService(googletag.pubads());
                      googletag.pubads().enableSingleRequest();
                      googletag.pubads().setTargeting('Category', ['']);
                      googletag.pubads().setTargeting('Keywords', '');
                      googletag.enableServices();
                    }); // apstag.init({
                    //   pubID: '7f0bbd82-5a13-48ec-9950-fcb028b1546c',
                    //   adServer: 'googletag',
                    //   bidTimeout: 2e3
                    // });
                    // // request the bids for the four googletag slots
                    // apstag.fetchBids({
                    //   slots: [
                    // ]
                    // }, function(bids) {
                    //   // set apstag bids, then trigger the first request to GAM
                    //   googletag.cmd.push(function() {
                    //     apstag.setDisplayBids();
                    //     googletag.pubads().refresh();    
                    //   });
                    // });

                    googletag.pubads().refresh();
                  });
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _onFirstScroll.apply(this, arguments);
    }

    function handleScroll() {
      onFirstScroll();
      window.removeEventListener("scroll", handleScroll);
    }

    window.addEventListener("scroll", handleScroll);
  }, []);
  var cateogry = "factcheck";
  var key = "FactCheck,TheLallantop";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {}), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: metaTags/* metaTags.factcheck.correctionPolicy.metaTitle */.V.factcheck.correctionPolicy.metaTitle,
      description: metaTags/* metaTags.factcheck.correctionPolicy.metaDescription */.V.factcheck.correctionPolicy.metaDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "content-wrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
        align: "center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center"
            },
            children: "Advertisement"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            id: size.width > 600 ? "div-gpt-ad-1701945163318-0" : "div-gpt-ad-1701946028239-0",
            style: {
              minWidth: "300px",
              minHeight: size.width > 600 ? "100px" : "260px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: size.width > 600 ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1686741281219-0')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})"
              }
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "outer-container-info-page",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "backlink-bar terms-title",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "/all/factcheck",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
                className: "icon-back-arrow"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "fact_check",
              defaultMessage: "\u092A\u0921\u093C\u0924\u093E\u0932"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: language == "hi" ? "भूल सुधार" : "Correction Policy"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "\u092A\u0921\u093C\u0924\u093E\u0932 \u0932\u093F\u0916\u0924\u0947 \u0935\u0915\u094D\u0924 \u0939\u092E\u093E\u0930\u0940 \u0915\u094B\u0936\u093F\u0936 \u0930\u0939\u0924\u0940 \u0939\u0948 \u0915\u093F \u092E\u093E\u092E\u0942\u0932\u0940 \u0917\u093C\u0932\u0924\u0940 \u092D\u0940 \u0930\u093F\u092A\u094B\u0930\u094D\u091F \u092E\u0947\u0902 \u0928 \u091C\u093E\u090F. \u0905\u0917\u0930 \u0907\u0938\u0915\u0947 \u092C\u093E\u0935\u091C\u0942\u0926 \u0915\u094B\u0908 \u092E\u093E\u0928\u0935\u0940\u092F \u092D\u0942\u0932 \u0939\u094B \u091C\u093E\u0924\u0940 \u0939\u0948, \u0924\u094B \u0909\u0938\u0947 \u0939\u092E \u0916\u0941\u0932\u0947 \u092E\u0928 \u0938\u0947 \u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902 \u0914\u0930 \u0924\u0924\u094D\u0915\u093E\u0932 \u0938\u0941\u0927\u093E\u0930\u0924\u0947 \u0939\u0948\u0902. \u091C\u093F\u0938 \u092D\u0940 \u0930\u093F\u092A\u094B\u0930\u094D\u091F \u092E\u0947\u0902 \u0910\u0938\u093E \u0938\u0941\u0927\u093E\u0930 \u0915\u093F\u092F\u093E \u091C\u093E\u0924\u093E \u0939\u0948, \u0909\u0938\u0915\u0947 \u0906\u0916\u093F\u0930 \u092E\u0947\u0902 \u0907\u0938\u0915\u0940 \u091C\u093E\u0928\u0915\u093E\u0930\u0940 \u0926\u0940 \u091C\u093E\u0924\u0940 \u0939\u0948. \u0905\u0917\u0930 \u0915\u094B\u0908 \u092C\u0921\u093C\u0940 \u0924\u0925\u094D\u092F\u093E\u0924\u094D\u092E\u0915 \u0917\u093C\u0932\u0924\u0940 \u0939\u094B \u092F\u093E \u0910\u0938\u0940 \u0917\u093C\u0932\u0924\u0940 \u0915\u093F \u0939\u092E\u0947\u0902 \u092B\u0948\u0915\u094D\u091F \u091A\u0947\u0915 \u0915\u093E \u0928\u093F\u0937\u094D\u0915\u0930\u094D\u0937 \u0939\u0940 \u092C\u0926\u0932\u0928\u093E \u092A\u0921\u093C\u0947, \u0924\u094B \u0939\u092E \u0930\u093F\u092A\u094B\u0930\u094D\u091F \u0915\u0940 \u0936\u0941\u0930\u0941\u0906\u0924 \u092E\u0947\u0902 \u092A\u094D\u0930\u092E\u0941\u0916\u0924\u093E \u0938\u0947 \u0907\u0938\u0947 \u0926\u093F\u0916\u093E\u0924\u0947 \u0939\u0948\u0902. \u0939\u093E\u0932\u093E\u0902\u0915\u093F, \u0935\u0930\u094D\u0924\u0928\u0940 \u0915\u0940 \u092E\u093E\u092E\u0942\u0932\u0940 \u0905\u0936\u0941\u0926\u094D\u0927\u093F\u092F\u093E\u0902 \u0938\u0941\u0927\u093E\u0930\u0928\u0947 \u092A\u0930 \u0939\u092E \u0906\u0930\u094D\u091F\u093F\u0915\u0932 \u092E\u0947\u0902 \u0905\u092A\u0921\u093C\u0947\u091F \u0928\u0939\u0940\u0902 \u091C\u094B\u0921\u093C\u0924\u0947. \u0905\u0917\u0930 \u0906\u092A \u0939\u092E\u093E\u0930\u0947 \u092A\u0921\u093C\u0924\u093E\u0932 \u0915\u0947 \u0924\u0930\u0940\u0915\u0947 \u092F\u093E \u0928\u0924\u0940\u091C\u0947 \u0938\u0947 \u0905\u0938\u0939\u092E\u0924 \u0939\u0948\u0902, \u0924\u094B \u0939\u092E\u0947\u0902 \u092E\u0947\u0932 \u0915\u0930\u0947\u0902 padtaal@lallantop.com \u092A\u0930. \u0939\u092E \u0906\u092A\u0915\u0940 \u0905\u0938\u0939\u092E\u0924\u093F \u092F\u093E \u0936\u093F\u0915\u093E\u092F\u0924 \u0915\u093E \u0938\u0902\u091C\u094D\u091E\u093E\u0928 \u091C\u093C\u0930\u0942\u0930 \u0932\u0947\u0902\u0917\u0947. \u0928\u093F\u092F\u092E\u093F\u0924 \u092B\u0940\u0921\u092C\u0948\u0915 \u0915\u0947 \u0932\u093F\u090F \u0906\u092A \u092A\u0921\u093C\u0924\u093E\u0932 \u0915\u0947 \u0938\u094B\u0936\u0932 \u092E\u0940\u0921\u093F\u092F\u093E \u0939\u0948\u0902\u0921\u0932\u094D\u0938 \u0915\u093E \u0907\u0938\u094D\u0924\u0947\u092E\u093E\u0932 \u0915\u0930 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
        align: "center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center"
            },
            children: "Advertisement"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            id: size.width > 600 ? "div-gpt-ad-1701945220410-1" : "div-gpt-ad-1701946028239-1",
            style: {
              minWidth: "300px",
              minHeight: size.width > 600 ? "100px" : "260px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: size.width > 600 ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})"
              }
            })
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var correction_policy = (CorrectionPolicy);
;// CONCATENATED MODULE: ./src/pages/factcheck-correction-policy.js


var __N_SSP = true;
function Privacy() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(correction_policy, {});
}

/***/ }),

/***/ 51421:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/factcheck-correction-policy",
      function () {
        return __webpack_require__(85569);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,9195,532,2888,179], function() { return __webpack_exec__(51421); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);